<script>
  const interests = [
    { emoji: '🧘', text: 'Meditation' },
    { emoji: '🥾', text: 'Hiking' },
    { emoji: '🚴', text: 'Cycling' },
    { emoji: '💻', text: 'Coding' },
    { emoji: '🍳', text: 'Cooking' },
    { emoji: '📚', text: 'Reading books' }
  ];
</script>

<div class="space-y-3">
  <div class="flex flex-wrap gap-3">
    {#each interests as { emoji, text }}
      <div class="group flex items-center gap-2 
        px-3 py-1.5 rounded-xl
        bg-white/50 dark:bg-gray-900/50 
        border border-gray-200/50 dark:border-gray-700/50
        hover:border-blue-500 dark:hover:border-blue-500
        backdrop-blur-sm
        transition-all duration-300 hover:scale-105">
        <span class="text-xl group-hover:scale-110 transition-transform duration-300">
          {emoji}
        </span>
        <span class="text-gray-700 dark:text-gray-200">{text}</span>
      </div>
    {/each}
  </div>
</div> 